import { api } from "../api";
import moment from "moment";

export const analyticsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getActivityList: builder.query({
            query: ({ startDate, endDate, searchTerm, page }) => {
                const params = new URLSearchParams();

                if (startDate && endDate && moment(startDate, moment.ISO_8601, true).isValid() && moment(endDate, moment.ISO_8601, true).isValid()) {
                    params.append('startDate', startDate);
                    params.append('endDate', endDate);
                }

                if (searchTerm) {
                    params.append('search', searchTerm);
                }

                if (page) {
                    params.append('page', page);
                }

                return {
                    url: `/adspresso/tracklist/dashboard/active_clients${params.toString() ? `?${params.toString()}` : ''}`,
                };
            },
            transformResponse: (response, meta, arg) => response.data,
        }),
        getExportData: builder.query({
            query: ({ startDate, endDate, searchTerm }) => {
              const params = new URLSearchParams();
          
              if (
                startDate &&
                endDate &&
                moment(startDate, moment.ISO_8601, true).isValid() &&
                moment(endDate, moment.ISO_8601, true).isValid()
              ) {
                params.append('startDate', startDate);
                params.append('endDate', endDate);
              }
          
              if (searchTerm) {
                params.append('search', searchTerm);
              }
          
              return {
                url: `/adspresso/tracklist/dashboard/export_active_clients${params.toString() ? `?${params.toString()}` : ''}`,
                responseHandler: (response) => response.text(),  // <-- RTK Query to get raw text
              };
            },
            transformResponse: (response, meta, arg) => response, // response will be CSV text
        }), 
        getActiveClientCount: builder.query({
          query: ({ startDate, endDate }) => {
              const params = new URLSearchParams();

              if (startDate && endDate && moment(startDate, moment.ISO_8601, true).isValid() && moment(endDate, moment.ISO_8601, true).isValid()) {
                  params.append('startDate', startDate);
                  params.append('endDate', endDate);
              }

              return {
                  url: `/adspresso/tracklist/dashboard/active-client/count${params.toString() ? `?${params.toString()}` : ''}`,
              };
          },
          transformResponse: (response, meta, arg) => response.data,
        }),
        getCampaignCount: builder.query({
          query: ({ startDate, endDate, searchTerm }) => {
              const params = new URLSearchParams();

              if (startDate && endDate && moment(startDate, moment.ISO_8601, true).isValid() && moment(endDate, moment.ISO_8601, true).isValid()) {
                  params.append('startDate', startDate);
                  params.append('endDate', endDate);
              }

              if (searchTerm) {
                  params.append('search', searchTerm);
              }

              return {
                  url: `/adspresso/tracklist/dashboard/campaign/count${params.toString() ? `?${params.toString()}` : ''}`,
              };
          },
          transformResponse: (response, meta, arg) => response.data,
        }),
        getActiveAdAccountCount: builder.query({
          query: ({ startDate, endDate, searchTerm }) => {
              const params = new URLSearchParams();

              if (startDate && endDate && moment(startDate, moment.ISO_8601, true).isValid() && moment(endDate, moment.ISO_8601, true).isValid()) {
                  params.append('startDate', startDate);
                  params.append('endDate', endDate);
              }

              if (searchTerm) {
                  params.append('search', searchTerm);
              }

              return {
                  url: `/adspresso/tracklist/dashboard/active-adAccount/count${params.toString() ? `?${params.toString()}` : ''}`,
              };
          },
          transformResponse: (response, meta, arg) => response.data,
        }),
    }),

});

export const { useGetActivityListQuery, useGetExportDataQuery, useLazyGetExportDataQuery, useGetActiveClientCountQuery, useGetCampaignCountQuery, useGetActiveAdAccountCountQuery } = analyticsApi;